<template>
  <div :class="classes" :style="styles"></div>
</template>

<script>
  export default {
    name: 'cGradient',
    props: {
      direction: {
        type: String,
        default: 'bottom',
        description: '(up / right / bottom / left)'
      },
      opacity: {
        type: Number,
        default: 1
      }
    },
    computed: {
      styles() {
        return {
          'background-image': `linear-gradient(to ${this.direction}, rgba(255, 255, 255, 0), rgb(0, 0, 0))`,
          opacity: this.opacity
        }
      },
      classes() {
        return [
          'c-gradient'
        ]
      },
    }
  }
</script>

<style lang="scss" scoped>
  .c-gradient {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }
</style>


